import api from "@/services/api"

export type EndOfDayReportMetrics = {
  cashTransactionCount: number
  cashTransactionAmount: number
  cardTransactionCount: number
  cardTransactionAmount: number
  cardGratuityAmount: number
  cashGratuityAmount: number
  cashRefundCount: number
  cashRefundAmount: number
  cardRefundCount: number
  cardRefundAmount: number
  cashbackCount: number
  cashbackAmount: number
  saleVoidCount: number
  saleVoidAmount: number
  refundVoidCount: number
  refundVoidAmount: number
}

export type CashierEndOfDayReport =
  EndOfDayReportMetrics & {
    cashierId: string | null
    cashierName: string
  }

export type RetreiveEndOfDayReportResponse =
  EndOfDayReportMetrics & {
    cashierBreakdown: CashierEndOfDayReport[]
  }

export const retreiveEndOfDayReport = async () => {
  const { body } =
    await api.get<RetreiveEndOfDayReportResponse>(
      "/reports/end-of-day"
    )

  return body
}
